<div class="workflow-templates">
    <div class="main-content">
        <div class="workflow-templates__inner">
            <!-- Loading State -->
            <div v-if="loading" class="loading-container">
                <div class="spinner"></div>
                <p>Loading templates...</p>
            </div>

            <!-- Error State -->
            <div v-else-if="error" class="error-container">
                <i class="bi bi-exclamation-triangle"></i>
                <h2>{{ error }}</h2>
                <button class="btn btn-primary" @click="fetchTemplates()">Try Again</button>
            </div>

            <!-- Main Content -->
            <div v-else>
                <!-- Header -->
                <div class="page-header">
                    <h1>Choose a Template</h1>
                    <p>Choose a template to get started quickly, or create a custom workflow from scratch.</p>
                </div>

                <!-- Search and Filter -->
                <div class="toolbar">
                    <div class="search-box">
                        <i class="bi bi-search search-icon"></i>
                        <input type="text" id="searchInput" placeholder="Search templates..." @keyup="filterTemplates()">
                    </div>
                </div>

                <!-- Categories -->
                <div class="categories">
                    <div class="category-chip" 
                         :class="{ active: activeCategory === 'all' }" 
                         @click="filterByCategory('all', $event)" 
                         data-category="all">
                        All Templates
                        <span class="count">{{ Object.keys(templates).length }}</span>
                    </div>
                    <div class="category-chip" 
                         v-for="cat in categories" 
                         :key="cat.name"
                         :class="{ active: activeCategory === cat.name }" 
                         @click="filterByCategory(cat.name, $event)" 
                         :data-category="cat.name">
                        {{ cat.displayName }}
                        <span class="count">{{ cat.count }}</span>
                    </div>
                </div>

                <!-- Templates by Category -->
                <div class="templates-container" id="templatesContainer">
                    <!-- Template sections will be rendered dynamically -->
                </div>

                <!-- Footer Actions -->
                <div class="page-actions">
                    <div class="selected-info">
                        <span style="color: var(--gray); font-size: 14px;" id="selectionText">No template selected</span>
                        <div class="selected-template-preview" id="selectedPreview" style="display: none;">
                            <div class="icon"><i class="bi bi-clipboard-check"></i></div>
                            <div class="info">
                                <div class="label">Selected Template</div>
                                <div class="name" id="selectedTemplateName">-</div>
                            </div>
                        </div>
                    </div>
                    <div class="action-buttons">
                        <button class="btn btn-secondary" @click="goBack()">
                            <i class="bi bi-arrow-left"></i> Back
                        </button>
                        <button class="btn btn-primary" id="continueBtn" disabled @click="create()">
                            Continue <i class="bi bi-arrow-right"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Preview Modal -->
    <div class="modal-overlay" id="previewModal">
        <div class="modal">
            <div class="modal-header">
                <div class="modal-header-content">
                    <h2 id="modalTitle">Template Preview</h2>
                    <span class="modal-category-badge" id="modalCategoryBadge"></span>
                </div>
                <button class="modal-close" @click="closeModal()"><i class="bi bi-x"></i></button>
            </div>
            <div class="modal-body">
                <div class="preview-section">
                    <h3>Description</h3>
                    <p class="preview-description" id="modalDescription">
                        Complete Know Your Customer verification workflow including ID verification, proof of address, and facial recognition.
                    </p>
                    <p class="category-description" id="modalCategoryDescription" style="display: none;"></p>
                </div>
                <div class="preview-section">
                    <h3>Included Services</h3>
                    <div class="services-list" id="servicesList">
                        <!-- Services will be populated dynamically -->
                    </div>
                </div>
                <div class="preview-section">
                    <h3>Workflow Settings</h3>
                    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px;">
                        <div class="service-item">
                            <i class="bi bi-people" style="font-size: 20px; color: var(--primary-color);"></i>
                            <div class="service-info">
                                <div class="service-name">Multiple Onboarding</div>
                                <div class="service-type" id="multipleOnboarding">Enabled</div>
                            </div>
                        </div>
                        <div class="service-item">
                            <i class="bi bi-box-seam" style="font-size: 20px; color: var(--primary-color);"></i>
                            <div class="service-info">
                                <div class="service-name">Batch Processing</div>
                                <div class="service-type" id="batchOnboarding">Disabled</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-secondary" @click="closeModal()">Close</button>
                <button class="btn btn-primary" @click="selectAndContinue()">
                    Select & Continue <i class="bi bi-arrow-right"></i>
                </button>
            </div>
        </div>
    </div>

</div>
